module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"groupByProducer":"Nach Herkunft","groupByConsumer":"Nach Verwendungszweck","pvParetoChart":"Ausbau PV im gewählten Szenario","pvParetoChartAll":"Ausbau PV Best-Case","production":"Stromproduktion (pro m²)","absoluteProduction":"Stromproduktion","peakProduction":"Nennleistung","loadingMessage":"Daten werden geladen. Bitte warten..."}}')
  delete Component.options._Ctor
}
